import { createSlice } from "@reduxjs/toolkit";
// utils
import { DefaultTableSize } from "src/config";

// ----------------------------------------------------------------------

// type Registry = {
//   key: String,
//   order: String,
//   orderBy: String,
//   page: Number,
//   rowsPerPage: Number,
//   defaultOrderBy: Number,
//   defaultOrder: Number,
//   defaultRowsPerPage: number,
//   defaultCurrentPage: Number,
// };

const initialState = {
  isLoading: false,
  error: false,
  registry: [],
  currentRegistry: {
    key: "",
    order: "asc",
    orderBy: "",
    page: 0,
    rowsPerPage: DefaultTableSize[0],
    selected: [],
    dense: true,
    filterName: "",
  },
};

const slice = createSlice({
  name: "rows",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getOrAddSuccess(state, action) {
      const { key, orderBy, rowsPerPage, order } = action.payload;
      const row = state.registry.find((row) => row.key === key);
      if (row) {
        state.currentRegistry = row;
      } else {
        let current = {
          key,
          order: order,
          orderBy: orderBy,
          rowsPerPage: rowsPerPage,
          page: 0,
          selected: [],
          dense: true,
        };
        state.registry.push(current);
        state.currentRegistry = current;
      }
    },

    setOrder(state, action) {
      state.registry = state.registry.map((row) => {
        if (row.key === action.payload.key) {
          row.order = action.payload.order;
          state.currentRegistry = row;
        }
        return row;
      });
    },

    setOrderBy(state, action) {
      state.registry = state.registry.map((row) => {
        if (row.key === action.payload.key) {
          row.orderBy = action.payload.orderBy;
          state.currentRegistry = row;
        }
        return row;
      });
    },

    setPage(state, action) {
      state.registry = state.registry.map((row) => {
        if (row.key === action.payload.key) {
          row.page = action.payload.page;
          state.currentRegistry = row;
        }
        return row;
      });
    },

    setRowsPerPage(state, action) {
      state.registry = state.registry.map((row) => {
        if (row.key === action.payload.key) {
          row.rowsPerPage = action.payload.rowsPerPage;
          state.currentRegistry = row;
        }
        return row;
      });
    },

    setSelected(state, action) {
      state.registry = state.registry.map((row) => {
        if (row.key === action.payload.key) {
          row.selected = action.payload.selected;
          state.currentRegistry = row;
        }
        return row;
      });
    },

    setDense(state, action) {
      state.registry = state.registry.map((row) => {
        if (row.key === action.payload.key) {
          row.dense = action.payload.dense;
          state.currentRegistry = row;
        }
        return row;
      });
    },

    setFilterName(state, action) {
      state.registry = state.registry.map((row) => {
        if (row.key === action.payload.key) {
          row.filterName = action.payload.filterName;
          state.currentRegistry = row;
        }
        return row;
      });
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  getOrAddSuccess,
  setOrder,
  setOrderBy,
  setPage,
  setRowsPerPage,
  setSelected,
  setDense,
  setFilterName,
} = slice.actions;

// ----------------------------------------------------------------------
